import { render, staticRenderFns } from "./RegisterValidate.vue?vue&type=template&id=3f123136"
import script from "./RegisterValidate.vue?vue&type=script&lang=ts"
export * from "./RegisterValidate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports